import {AcquisitionType, BenefitType, ShippingType, SubscriptionStatus, UnitType} from "../helpers/constants";
import {PaymentHistory} from "./payment-history";
import {Beneficiary} from "./beneficiary";
import {Voucher} from "./voucher";
import {County} from "../helpers/enums";
import {OrderBudgetPaymentHistory} from "./order-budget-payment-history";
import {OrderCardPaymentHistory} from "./order-card-payment-history";
import { DynamicAttribute } from "./dynamic-attribute";
import { CompanyBenefitPolicyRequiredFieldTypeEnum } from "./company-benefit-policy";

export interface SubmittedRequiredDocument {
  uploadedDocumentName: string;
  uploadedDocumentUrl: string;
}

export interface SubmittedConsent {
  name: string;
  checked: boolean;
}

export interface SubmittedRequiredField {
  fieldLabel: string;
  value: string;
  fieldType: CompanyBenefitPolicyRequiredFieldTypeEnum;
}

export class OrderDetails {
  benefitId: number;
  providerId: number;
  name?: string;
  amountWithVAT?: number;
  date?: Date;
  noOfUnits?: number;
  companyTaxDistribution?: number;
  shippingType: ShippingType;
  shippingTypeLabel: string;
  acquisitionType: AcquisitionType;
  benefitType: BenefitType;
  benefitTaxCategory: 0|1|2|3;
  pictureUrl?: string;
  providerName?: string;
  cardPaymentHistory?: Array<OrderCardPaymentHistory>;
  budgetPaymentHistory?: Array<OrderBudgetPaymentHistory>;
  benefitDescription?: string;
  taxCompany: number;
  taxEmployee: number;
  camTax?: number;
  orderStatus?: number;
  orderStatusLabel?: string;
  subscriptionStatus?: SubscriptionStatus;
  subscriptionStatusLabel?: string;
  beneficiary?: Beneficiary;
  isPlacedByAdmin: boolean;
  vouchers?: Array<Voucher>;
  locations?: Array<County>;
  isDeleted: boolean;
  isOrderInCurrentMonth: boolean;
  isAutoOrderEnabled?: boolean;
  hasAutoOrderDynamicQuantity?: boolean;
  subscriptionNumberOfMonths?: number;
  billingAddressId?: number;
  shippingAddressId?: number;
  dynamicAttributes?: Array<DynamicAttribute>;
  submittedRequiredDocuments?: Array<SubmittedRequiredDocument>;
  submittedConsents?: Array<SubmittedConsent>;
  submittedRequiredFields?: Array<SubmittedRequiredField>;
  paidFromSalary?: boolean;
}
